import React from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { AppDataProvider } from "./Providers/AppDataProvider";

const root = createRoot(document.getElementById("root"));
root.render(
  <AppDataProvider>
    <App />
  </AppDataProvider>
);
